import axios from "@/api/axiosInstance";
import type { CompanySubscriptionAgreementsResponse } from "./types";

export const getCompanySubscriptionAgreements =
  async (): Promise<CompanySubscriptionAgreementsResponse> => {
    const response = await axios.get<CompanySubscriptionAgreementsResponse>(
      "/api/private/subscription-agreement/company",
    );
    return response.data;
  };
